// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   SoltArc — Architectural Theme Overrides
   Loaded after public/assets/css/style.css via index.js import.
   Rules here win by specificity / !important where needed.
   ================================================================ */

/* ─── DESIGN TOKENS ────────────────────────────────────────────── */
:root {
  --bg:        #F7F5F2;
  --bg-alt:    #EEEAE5;
  --ink:       #1A1A1A;
  --ink-muted: #7A736B;
  --accent:    #3F97A0;
  --line:      #D8D3CD;
  --dark:      #141414;
}

/* ─── GLOBAL ────────────────────────────────────────────────────── */
*, *::before, *::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  background-color: var(--bg);
  color: var(--ink);
  font-family: 'Poppins', sans-serif;
  font-weight: 300;
  font-size: 15px;
  line-height: 1.85;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

::selection {
  background-color: var(--accent);
  color: #fff;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* ─── BACKGROUNDS ───────────────────────────────────────────────── */
body,
.bg-white {
  background-color: var(--bg) !important;
}

.bg-gray {
  background-color: var(--bg-alt) !important;
}

/* ─── TYPOGRAPHY ────────────────────────────────────────────────── */
h1, h2 {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  color: var(--ink);
  letter-spacing: -0.01em;
  line-height: 1.15;
}

h1 { font-size: 64px; }
h2 { font-size: 48px; }

h3 {
  font-family: 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: var(--ink);
}

h4 {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: var(--ink);
}

h5, h6 {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: var(--ink);
}

p {
  color: var(--ink-muted);
  font-weight: 300;
  line-height: 1.85;
}

@media (max-width: 768px) {
  h1 { font-size: 42px; }
  h2 { font-size: 34px; }
  h3 { font-size: 22px; }
}

/* ─── SECTION LAYOUT ─────────────────────────────────────────────── */
.content-inner-2 {
  padding-top: 100px !important;
  padding-bottom: 100px !important;
}

.section-head {
  margin-bottom: 48px;
}

/* Strip the decorative cross-line background from separators */
.sx-separator-outer,
.sx-separator {
  background-image: none !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.sx-separator .sep-line-one {
  font-family: 'Cormorant Garamond', Georgia, serif !important;
  font-size: 42px !important;
  font-weight: 300 !important;
  color: var(--ink) !important;
  background: none !important;
  border: none !important;
  padding: 0 !important;
}

/* Elimina las rayitas/líneas negras que el tema dibuja a los lados (y a veces
   encima) de los títulos .sep-line-one mediante los pseudo-elementos
   :before/:after (background:#000; height:4px). Las queremos fuera en TODO el
   sitio, sin importar el wrapper (.sx-separator-outer.separator-left/right/center). */
.sep-line-one::before,
.sep-line-one::after {
  display: none !important;
  content: none !important;
}

/* ─── BUTTONS ─────────────────────────────────────────────────────── */
.site-button {
  background-color: transparent !important;
  border: 1.5px solid var(--accent) !important;
  color: var(--ink) !important;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 14px 32px;
  border-radius: 0 !important;
  transition: background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;
}

.site-button:hover,
.site-button:focus {
  background-color: var(--accent) !important;
  border-color: var(--accent) !important;
  color: #fff !important;
  text-decoration: none;
}

.site-button-secondry {
  background-color: var(--ink) !important;
  border: 1.5px solid var(--ink) !important;
  color: #fff !important;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 14px 32px;
  border-radius: 0 !important;
  transition: background-color 0.25s ease, border-color 0.25s ease;
}

.site-button-secondry:hover {
  background-color: var(--accent) !important;
  border-color: var(--accent) !important;
  color: #fff !important;
}

.site-button-link {
  color: var(--accent) !important;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-decoration: none !important;
  transition: color 0.2s ease;
}

.site-button-link:hover {
  color: var(--ink) !important;
  text-decoration: none !important;
}

/* ─── HEADER ──────────────────────────────────────────────────────── */
.site-header .main-bar {
  background-color: rgba(247, 245, 242, 0.96) !important;
  border-bottom: 1px solid var(--line);
  backdrop-filter: blur(8px);
}

.site-header.sticky-header .main-bar,
.site-header.color-fill .main-bar {
  background-color: var(--bg) !important;
  box-shadow: 0 1px 0 var(--line);
}

.header-nav .nav > li > a {
  color: var(--ink) !important;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.header-nav .nav > li > a:hover,
.header-nav .nav > li.active > a {
  color: var(--accent) !important;
}

.header-nav .nav > li > ul.sub-menu,
.header-nav .nav > li > ul.mega-menu,
.header-nav .nav > li ul.sub-menu,
.header-nav .nav > li ul.sub-menu li ul.sub-menu {
  background-color: #ffffff !important;
  border-top: 2px solid var(--accent) !important;
  box-shadow: 0 8px 24px rgba(20, 20, 20, 0.08) !important;
}

.header-nav .nav > li ul.sub-menu li,
.header-nav .nav > li ul.sub-menu li > a {
  background-color: #ffffff !important;
}

.header-nav .nav > li ul.sub-menu li a {
  color: var(--ink) !important;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: none;
  padding: 10px 18px !important;
}

.header-nav .nav > li ul.sub-menu li a:hover,
.header-nav .nav > li ul.sub-menu li:hover > a,
.header-nav .nav > li ul.sub-menu li.active > a {
  color: var(--accent) !important;
  background-color: var(--bg-alt) !important;
}

/* Mobile drawer — same legibility */
.mobile-sider-drawer-menu .header-nav .nav li ul.sub-menu {
  background-color: #ffffff !important;
}
.mobile-sider-drawer-menu .header-nav .nav li ul.sub-menu li a {
  color: var(--ink) !important;
}

/* Drawer móvil ABIERTO: los items de primer nivel van sobre el panel OSCURO →
   texto crema legible. Doble guarda: SOLO en ancho móvil (≤991px, donde el nav
   se vuelve drawer) y con .active. Así el nav de ESCRITORIO (texto oscuro sobre
   la barra clara) NUNCA se ve afectado. */
@media (max-width: 991px) {
  .mobile-sider-drawer-menu.active .header-nav .nav > li > a {
    color: var(--bg) !important;
  }
  .mobile-sider-drawer-menu.active .header-nav .nav > li > a:hover,
  .mobile-sider-drawer-menu.active .header-nav .nav > li.active > a {
    color: var(--accent) !important;
  }
}

/* Mobile menu */
.mobile-nav > li > a {
  color: var(--ink) !important;
}

/* ─── SERVICE CARDS — minimalist numbered grid ─────────────────── */
.svc-section-label {
  font-family: 'Poppins', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: var(--accent);
  margin: 0 0 12px 0;
}

/* El tema aplica \`.section-head h2 { font-family: Poppins }\` (mayor especificidad
   que esta clase) + el \`h2 { font-weight: 600 }\` global, lo que hacía que este
   título saliera en Poppins negrita. Forzamos la tipografía serif fina y elegante
   (Cormorant Garamond 300), igual que el resto de los títulos del sitio. */
.svc-section-title {
  font-family: 'Cormorant Garamond', Georgia, serif !important;
  font-size: 48px;
  font-weight: 300 !important;
  color: var(--ink);
  margin: 0 0 56px 0;
  line-height: 1.15;
  letter-spacing: -0.01em;
}

.svc-card {
  padding: 36px 0;
  border-top: 1px solid var(--line);
  transition: border-top-color 0.25s ease;
  height: 100%;
}

.svc-card:hover {
  border-top-color: var(--accent);
}

.svc-number {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: 17px;
  font-weight: 300;
  line-height: 1;
  color: var(--line);
  margin-bottom: 6px;
  display: block;
  transition: color 0.25s ease;
}

.svc-card:hover .svc-number {
  color: var(--accent);
}

.svc-title {
  font-family: 'Poppins', sans-serif !important;
  font-size: 10px !important;
  font-weight: 600 !important;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--ink) !important;
  margin: 0 0 14px 0 !important;
}

.svc-desc {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.85;
  color: var(--ink-muted);
  margin-bottom: 22px;
}

.svc-link {
  font-family: 'Poppins', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--accent);
  text-decoration: none !important;
  display: inline-block;
  transition: color 0.2s ease;
}

.svc-link:hover {
  color: var(--ink);
  text-decoration: none !important;
}

/* ─── ABOUT SECTION ─────────────────────────────────────────────── */
.about-home-left h2 {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 48px;
  color: var(--ink);
  line-height: 1.2;
}

/* ─── INNER PAGE BANNER ──────────────────────────────────────────── */
/* El tema deja el banner en 500px (demasiado alto). Lo hacemos compacto pero con
   min-height (no height fijo) para que CREZCA cuando el texto es largo (p.ej.
   Protección de Datos) y no se corte arriba. El padding-top da aire al título
   para que nunca quede pegado al borde superior. */
.sx-bnr-inr {
  height: auto;
  min-height: 340px;
}

/* padding-top generoso: el header fijo (~80px) se monta sobre el banner, así
   que el título necesita ese colchón para no quedar pegado/cortado arriba. */
.sx-bnr-inr-entry {
  padding-top: 110px;
  padding-bottom: 40px;
}

@media (max-width: 768px) {
  .sx-bnr-inr {
    min-height: 280px;
  }
  .sx-bnr-inr-entry {
    padding-top: 80px;
    padding-bottom: 32px;
  }
}

.sx-bnr-inr h2 {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  letter-spacing: -0.01em;
}

/* ─── FOOTER ─────────────────────────────────────────────────────── */
.site-footer {
  background-color: var(--dark) !important;
}

/* Contenedor del footer más ancho: cada bloque se ancla a su orilla (en vez de
   flotar en un contenedor angosto centrado). Recargado de cada lado. */
.site-footer .container {
  width: 90%;
  max-width: 1500px;
}

/* Distribución del footer: bloque izquierdo pegado a la izquierda, bloque
   derecho pegado a la derecha, centro vacío. */
.footer-split {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 48px;
  flex-wrap: wrap;
}
.footer-split-left {
  flex: 0 1 360px;
  min-width: 250px;
}
.footer-split-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;   /* empuja columnas y botón a la orilla derecha */
  gap: 28px;
  text-align: right;       /* títulos/datos alineados a la derecha (espejo del lado izquierdo) */
}
.footer-right-cols {
  display: flex;
  gap: 72px;
}
.footer-right-cols .widget {
  margin-bottom: 0;
}
/* El bloque "Conoce más / Envíanos un mensaje" ahora vive en la columna derecha,
   debajo del botón CONTÁCTANOS. Le damos aire respecto al botón (arriba) y, por el
   gap de .footer-split-right, también respecto a los datos de contacto (teléfono). */
.footer-cta {
  margin-top: 14px;
  padding-top: 22px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  width: 100%;
}

/* ─── REDES SOCIALES DEL FOOTER ──────────────────────────────────────
   Círculo sutil con el icono blanco (se ve de qué red es) y, al pasar el
   cursor, se rellena con el color de la marca + un pequeño levantamiento. */
.site-footer .footer-social {
  display: flex;
  gap: 12px;
  margin: 10px 0 0;
  padding: 0;
}
.site-footer .footer-social li {
  margin: 0;
  padding: 0;
}
.site-footer .footer-social li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff !important;
  font-size: 17px;
  line-height: 1;
  transition: transform 0.2s ease, background 0.2s ease,
    border-color 0.2s ease, box-shadow 0.2s ease;
}
.site-footer .footer-social li a:hover {
  transform: translateY(-3px);
  color: #fff !important;
  border-color: transparent;
}
.site-footer .footer-social .social-fb:hover {
  background: #1877f2;
  box-shadow: 0 6px 16px rgba(24, 119, 242, 0.45);
}
.site-footer .footer-social .social-ig:hover {
  background: radial-gradient(circle at 30% 110%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285aeb 90%);
  box-shadow: 0 6px 16px rgba(214, 36, 159, 0.45);
}
.site-footer .footer-social .social-in:hover {
  background: #0a66c2;
  box-shadow: 0 6px 16px rgba(10, 102, 194, 0.45);
}

@media (max-width: 767px) {
  .footer-split {
    flex-direction: column;
    gap: 40px;
  }
  .footer-split-right {
    align-items: flex-start;
    text-align: left;
  }
  .footer-right-cols {
    gap: 40px;
  }
}

.site-footer p {
  color: rgba(255, 255, 255, 0.5) !important;
  font-weight: 300;
  font-size: 13px;
}

.site-footer h3,
.site-footer h4,
.site-footer h5,
.site-footer .widget-title {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  color: #fff !important;
  letter-spacing: 0;
}

.site-footer a {
  color: rgba(255, 255, 255, 0.55) !important;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0.3px;
  transition: color 0.2s ease;
}

.site-footer a:hover {
  color: var(--accent) !important;
  text-decoration: none;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.site-footer .site-button {
  border-color: var(--accent) !important;
  color: #fff !important;
}

.site-footer .site-button:hover {
  background-color: var(--accent) !important;
  color: #fff !important;
}

/* ─── CLIENT LOGOS ───────────────────────────────────────────────── */
.ow-client-logo img {
  filter: grayscale(100%);
  opacity: 0.45;
  transition: filter 0.3s ease, opacity 0.3s ease;
}

.ow-client-logo img:hover {
  filter: grayscale(0%);
  opacity: 1;
}

/* ─── LEGACY ICON BOXES (non-Services pages) ─────────────────────── */
.icon-count-2-outer {
  box-shadow: none !important;
  border: 1px solid var(--line) !important;
  border-radius: 0 !important;
  transition: border-color 0.25s ease;
}

.icon-count-2-outer:hover {
  box-shadow: none !important;
  border-color: var(--accent) !important;
}

.icon-count-2 {
  border-radius: 0 !important;
  box-shadow: none !important;
}

/* ─── MODULE HERO IMAGE (Services detail + Modulo pages) ────────── */
/* The PNG illustration for each of the 6 modules, half the size of
   the default block so it reads as a feature image, not a giant hero. */
.module-hero {
  text-align: center;
}

.module-hero-img {
  display: inline-block;
  width: 50%;
  max-width: 320px;
  height: auto;
}

@media (max-width: 768px) {
  .module-hero-img {
    width: 70%;
    max-width: 240px;
  }
}

/* ─── CTA ICON BOXES (Services detail pages) ─────────────────────── */
/* Half the size the template ships with. */
.sx-icon-box-lg {
  width: 50px !important;
  height: 50px !important;
  line-height: 50px !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px !important;
}

.sx-icon-box-lg .icon-cell,
.sx-icon-box-lg i {
  font-size: 22px !important;
  line-height: 1 !important;
}

.sx-icon-box-md {
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.sx-icon-box-md .icon-cell,
.sx-icon-box-md i {
  font-size: 18px !important;
}

/* ─── OWL CAROUSEL ───────────────────────────────────────────────── */
.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: var(--accent) !important;
}

.owl-theme .owl-nav [class*='owl-'] {
  background: transparent !important;
  color: var(--accent) !important;
  border: 1px solid var(--accent) !important;
  border-radius: 0 !important;
  transition: background 0.2s ease, color 0.2s ease;
}

.owl-theme .owl-nav [class*='owl-']:hover {
  background: var(--accent) !important;
  color: #fff !important;
}

/* ─── DECORATIVE BG TEXT ─────────────────────────────────────────── */
.hilite-title {
  display: none;
}

/* ─── SCROLL TO TOP ──────────────────────────────────────────────── */
button.scroltop {
  background-color: var(--accent) !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  /* Apilado SOBRE la burbuja de chat (bottom:28 + 52px alto + 12 de gap), mismo
     borde derecho, para que no se encimen. z-index < chat (9999): si el chat se
     abre, lo cubre. */
  right: 28px !important;
  bottom: 92px !important;
  z-index: 9998 !important;
}

/* ─── GLOBAL LINK TRANSITIONS ────────────────────────────────────── */
a {
  transition: color 0.2s ease;
}

/* ─── LANGUAGE SWITCH (ES / EN) ──────────────────────────────────── */
.lang-switch {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.lang-btn {
  background: transparent;
  border: none;
  padding: 4px 6px;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--ink-muted);
  cursor: pointer;
  transition: color 0.2s ease;
  line-height: 1;
}

.lang-btn:hover {
  color: var(--ink);
}

.lang-btn.is-active {
  color: var(--accent);
}

.lang-sep {
  color: var(--line);
  font-size: 11px;
  font-weight: 300;
  -webkit-user-select: none;
          user-select: none;
}

/* ─── ABOUT · SoltArc (editorial) ──────────────────────────────────── */
.about-copra {
  background: var(--bg);
  padding: 110px 0;
}

.about-copra-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  gap: 72px;
  align-items: center;
}

/* Imagen con marco desfasado en color de acento (toque editorial). */
.about-copra-figure {
  position: relative;
  margin: 0;
}
.about-copra-figure::before {
  content: '';
  position: absolute;
  left: -22px;
  top: 22px;
  width: 100%;
  height: 100%;
  border: 1px solid var(--accent);
  opacity: 0.5;
  z-index: 0;
  pointer-events: none;
}
.about-copra-figure .ac-img {
  position: relative;
  z-index: 1;
  width: 100%;
  aspect-ratio: 4 / 5;
  background-size: cover;
  background-position: center;
  filter: grayscale(100%) contrast(1.02);
  transition: filter 0.7s ease;
}
.about-copra-figure:hover .ac-img {
  filter: grayscale(0%);
}

.about-copra-eyebrow {
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  margin: 0 0 20px;
}

.about-copra-title {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 60px;
  line-height: 1;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin: 0 0 24px;
}

.about-copra-rule {
  width: 56px;
  height: 2px;
  background: var(--accent);
  margin: 0 0 30px;
}

.about-copra-lead {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  line-height: 1.75;
  font-weight: 400;
  color: var(--ink);
  margin: 0 0 24px;
}

.about-copra-body p {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  line-height: 1.9;
  font-weight: 300;
  color: var(--ink-muted);
  margin: 0 0 18px;
}
.about-copra-body p:last-child {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .about-copra {
    padding: 64px 0;
  }
  .about-copra-grid {
    grid-template-columns: 1fr;
    gap: 48px;
  }
  .about-copra-figure {
    max-width: 460px;
  }
  .about-copra-figure::before {
    left: -12px;
    top: 12px;
  }
  .about-copra-title {
    font-size: 46px;
  }
  .about-copra-lead {
    font-size: 16.5px;
  }
}

/* ─── ABOUT · feature (texto + media, minimalista) ───────────────── */
.about-feature {
  background: #fff;
  padding: 110px 0;
}

.about-feature-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 72px;
  align-items: center;
}

.about-feature-eyebrow {
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  margin: 0 0 20px;
}

.about-feature-title {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 44px;
  line-height: 1.08;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin: 0 0 24px;
}

.about-feature-rule {
  width: 56px;
  height: 2px;
  background: var(--accent);
  margin: 0 0 28px;
}

.about-feature-text {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  line-height: 1.9;
  font-weight: 300;
  color: var(--ink-muted);
  margin: 0 0 34px;
}

/* Enlace minimalista con flecha (en vez del botón con caja). */
.about-feature-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: var(--ink);
  text-decoration: none;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--ink);
  transition: color 0.25s ease, border-color 0.25s ease;
}
.about-feature-link:hover {
  color: var(--accent);
  border-color: var(--accent);
  text-decoration: none;
}
.about-feature-link .arw {
  transition: transform 0.25s ease;
}
.about-feature-link:hover .arw {
  transform: translateX(5px);
}

/* Media: imagen con marco de acento desfasado (espejo del de SoltArc). */
.about-feature-media {
  position: relative;
  line-height: 0;
}
.about-feature-media::after {
  content: '';
  position: absolute;
  right: -22px;
  bottom: -22px;
  width: 100%;
  height: 100%;
  border: 1px solid var(--accent);
  opacity: 0.5;
  z-index: 0;
  pointer-events: none;
}
.about-feature-media video,
.about-feature-media img {
  position: relative;
  z-index: 1;
  width: 100%;
  display: block;
  /* Recorta ~10% del borde inferior para ocultar la marca de agua (estrella)
     de la esquina inferior derecha. Imagen 944x1130 → se muestra 944x1017,
     anclada arriba (object-position: center top). */
  aspect-ratio: 944 / 1017;
  object-fit: cover;
  object-position: center top;
  filter: grayscale(100%) contrast(1.02);
  transition: filter 0.7s ease;
}
.about-feature-media:hover video,
.about-feature-media:hover img {
  filter: grayscale(0%);
}

@media (max-width: 991px) {
  .about-feature {
    padding: 64px 0;
  }
  .about-feature-grid {
    grid-template-columns: 1fr;
    gap: 44px;
  }
  .about-feature-title {
    font-size: 36px;
  }
  .about-feature-media::after {
    right: -12px;
    bottom: -12px;
  }
}

/* ─── ABOUT · declaración de cierre (minimalista) ────────────────── */
.about-statement {
  background: var(--bg);
  padding: 96px 0;
  text-align: center;
}

.about-statement-inner {
  max-width: 760px;
  margin: 0 auto;
}

/* Pequeña marca de acento centrada (sustituye las rayitas del sep-line-one). */
.about-statement-mark {
  width: 48px;
  height: 2px;
  background: var(--accent);
  margin: 0 auto 30px;
}

/* El texto se trata como una cita/lead en serif, no como título. */
.about-statement p {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 27px;
  line-height: 1.55;
  letter-spacing: 0.005em;
  color: var(--ink);
  margin: 0;
}

@media (max-width: 991px) {
  .about-statement {
    padding: 64px 0;
  }
  .about-statement p {
    font-size: 22px;
  }
}

/* ─── PROTECCIÓN DE DATOS (minimalista / moderno) ────────────────── */
.dp-section { padding: 104px 0; }
.dp-section.dp-cream { background: var(--bg); }
.dp-section.dp-white { background: #fff; }
.dp-section.dp-alt   { background: var(--bg-alt); }

.dp-eyebrow {
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  margin: 0 0 18px;
}
.dp-title {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 40px;
  line-height: 1.12;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin: 0 0 22px;
}
.dp-rule {
  width: 56px;
  height: 2px;
  background: var(--accent);
  margin: 0 0 26px;
}
.dp-text {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  line-height: 1.9;
  font-weight: 300;
  color: var(--ink-muted);
  margin: 0;
}
.dp-head-center {
  text-align: center;
  max-width: 680px;
  margin: 0 auto 56px;
}
.dp-head-center .dp-rule { margin-left: auto; margin-right: auto; }

/* Sección 1 — intro: visual minimalista (SVG línea) + texto */
.dp-intro-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 72px;
  align-items: center;
}
.dp-figure {
  position: relative;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid var(--line);
}
.dp-figure::after {
  content: '';
  position: absolute;
  left: -20px;
  top: 20px;
  width: 100%;
  height: 100%;
  border: 1px solid var(--accent);
  opacity: 0.45;
  z-index: 0;
  pointer-events: none;
}
.dp-figure svg {
  position: relative;
  z-index: 1;
  width: 132px;
  height: 132px;
  color: var(--accent);
}

/* Sección 2 — tres pilares (sin clip-art, número serif) */
.dp-pillars {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}
.dp-pillar {
  background: #fff;
  border: 1px solid var(--line);
  padding: 42px 34px;
  transition: border-color 0.25s ease, transform 0.25s ease;
}
.dp-pillar:hover {
  border-color: var(--accent);
  transform: translateY(-4px);
}
.dp-pillar-num {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 36px;
  line-height: 1;
  color: var(--accent);
  margin: 0 0 22px;
}
.dp-pillar h4 {
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: var(--ink);
  margin: 0;
}

/* Sección 3 — cómo trabajamos (lista 2 columnas con hairlines) */
.dp-grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 64px;
}
.dp-item {
  padding: 30px 0;
  border-top: 1px solid var(--line);
}
.dp-item-h {
  display: flex;
  align-items: baseline;
  gap: 14px;
  margin: 0 0 12px;
}
.dp-item-num {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 22px;
  color: var(--accent);
}
.dp-item h4 {
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: var(--ink);
  margin: 0;
}
.dp-item p {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  line-height: 1.85;
  font-weight: 300;
  color: var(--ink-muted);
  margin: 0;
}

/* Acciones / botones minimalistas (reutilizables en datos personales) */
.dp-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 12px;
}
.dp-actions.dp-actions-center { justify-content: center; }
.dp-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--ink);
  text-decoration: none;
  padding: 14px 28px;
  border: 1px solid var(--line);
  background: transparent;
  transition: border-color 0.25s ease, color 0.25s ease;
}
.dp-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
  text-decoration: none;
}
.dp-btn .arw { transition: transform 0.25s ease; }
.dp-btn:hover .arw { transform: translateX(4px); }

@media (max-width: 991px) {
  .dp-section { padding: 64px 0; }
  .dp-intro-grid { grid-template-columns: 1fr; gap: 44px; }
  .dp-figure { max-width: 340px; }
  .dp-pillars { grid-template-columns: 1fr; gap: 18px; }
  .dp-grid2 { grid-template-columns: 1fr; gap: 0; }
  .dp-title { font-size: 32px; }
}

/* ─── DETALLE DE SERVICIOS (minimalista / limpio) ────────────────── */
.svc-section { padding: 96px 0; }
.svc-section.svc-cream { background: var(--bg); }
.svc-section.svc-white { background: #fff; }
.svc-section.svc-alt   { background: var(--bg-alt); }

.svc-eyebrow {
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  margin: 0 0 18px;
}
.svc-title {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 40px;
  line-height: 1.12;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin: 0 0 22px;
}
.svc-rule {
  width: 56px;
  height: 2px;
  background: var(--accent);
  margin: 0 0 26px;
}
.svc-text {
  font-family: 'Poppins', sans-serif;
  font-size: 15.5px;
  line-height: 1.9;
  font-weight: 300;
  color: var(--ink-muted);
  margin: 0;
}
.svc-head-center {
  text-align: center;
  max-width: 680px;
  margin: 0 auto 52px;
}
.svc-head-center .svc-rule { margin-left: auto; margin-right: auto; }

/* Intro: captura del módulo + texto */
.svc-intro-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  gap: 72px;
  align-items: center;
}
.svc-media {
  position: relative;
  line-height: 0;
}
.svc-media::after {
  content: '';
  position: absolute;
  left: -20px;
  bottom: -20px;
  width: 100%;
  height: 100%;
  border: 1px solid var(--accent);
  opacity: 0.45;
  z-index: 0;
  pointer-events: none;
}
.svc-media img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: auto;
  display: block;
  border: 1px solid var(--line);
}

/* Características: lista limpia en 2 columnas con marca de acento */
.svc-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 56px;
}
.svc-feature {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 0;
  border-top: 1px solid var(--line);
}
.svc-feature::before {
  content: '';
  flex: 0 0 16px;
  height: 1px;
  background: var(--accent);
  margin-top: 12px;
}
.svc-feature span {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: var(--ink);
}

/* FAQ: acordeón minimalista con hairlines */
.svc-faq {
  max-width: 840px;
  margin: 0 auto;
}
.svc-faq-item { border-top: 1px solid var(--line); }
.svc-faq-item:last-child { border-bottom: 1px solid var(--line); }
.svc-faq-q {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  padding: 24px 0;
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.3;
  color: var(--ink);
}
.svc-faq-q .ind {
  flex: 0 0 auto;
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: 300;
  color: var(--accent);
  line-height: 1;
}
.svc-faq-a {
  padding: 0 0 24px;
  max-width: 90%;
}
.svc-faq-a p {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  line-height: 1.85;
  font-weight: 300;
  color: var(--ink-muted);
  margin: 0;
}

/* Tarjetas CTA limpias */
.svc-cta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
.svc-card {
  background: #fff;
  border: 1px solid var(--line);
  padding: 42px 40px;
  transition: border-color 0.25s ease, transform 0.25s ease;
}
.svc-card:hover {
  border-color: var(--accent);
  transform: translateY(-4px);
}
.svc-card .svc-card-ic {
  display: block;
  color: var(--accent);
  font-size: 26px;
  margin: 0 0 20px;
}
.svc-card h4 {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: 28px;
  line-height: 1.1;
  color: var(--ink);
  margin: 0 0 12px;
}
.svc-card p {
  font-family: 'Poppins', sans-serif;
  font-size: 14.5px;
  line-height: 1.8;
  font-weight: 300;
  color: var(--ink-muted);
  margin: 0 0 22px;
}
.svc-card-link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--ink);
  text-decoration: none;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--ink);
  transition: color 0.25s ease, border-color 0.25s ease;
}
.svc-card-link:hover {
  color: var(--accent);
  border-color: var(--accent);
  text-decoration: none;
}
.svc-card-link .arw { transition: transform 0.25s ease; }
.svc-card-link:hover .arw { transform: translateX(4px); }

/* Rejilla de 3 tarjetas (p.ej. "el problema" de los módulos). */
.svc-cards-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

@media (max-width: 991px) {
  .svc-section { padding: 64px 0; }
  .svc-intro-grid { grid-template-columns: 1fr; gap: 44px; }
  .svc-media { max-width: 560px; }
  .svc-features { grid-template-columns: 1fr; gap: 0; }
  .svc-cta-grid { grid-template-columns: 1fr; gap: 18px; }
  .svc-cards-3 { grid-template-columns: 1fr; gap: 18px; }
  .svc-title { font-size: 32px; }
  .svc-faq-a { max-width: 100%; }
}

/* Menú móvil: botón de cerrar (×) DENTRO del panel oscuro del drawer.
   El header es transparente, así que el fondo detrás de la hamburguesa
   cambia por página (claro en Precios, oscuro en Home) y ningún color
   único de la X sirve. El panel del menú (.header-nav.nav-dark) siempre
   es oscuro, por eso colocamos ahí una × blanca: visible en toda página
   y siempre por encima del panel (z-index > 999). */
.mobile-nav-close { display: none; }

@media only screen and (max-width: 991px) {
  .mobile-sider-drawer-menu .header-nav .mobile-nav-close {
    display: block;
    position: absolute;
    top: 8px;
    right: 14px;
    width: 44px;
    height: 44px;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #fff;
    font-size: 34px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    z-index: 1001;
  }
  .mobile-sider-drawer-menu .header-nav .mobile-nav-close:hover { opacity: 0.7; }

  /* Con el panel abierto, la hamburguesa se oculta: el menú se cierra
     con la × del panel (evita una X blanca/negra perdida sobre fondo variable). */
  .mobile-sider-drawer-menu.active .navbar-toggler { visibility: hidden; }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;qEAIqE;;AAErE,qEAAqE;AACrE;EACE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,+EAA+E;AACjF;;AAEA,sEAAsE;AACtE;;EAEE,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sEAAsE;AACtE;EACE,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,KAAK,eAAe,EAAE;AACtB,KAAK,eAAe,EAAE;;AAEtB;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,KAAK,eAAe,EAAE;EACtB,KAAK,eAAe,EAAE;EACtB,KAAK,eAAe,EAAE;AACxB;;AAEA,uEAAuE;AACvE;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;;sFAGsF;AACtF;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,wEAAwE;AACxE;EACE,wCAAwC;EACxC,4CAA4C;EAC5C,4BAA4B;EAC5B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,kFAAkF;AACpF;;AAEA;;EAEE,0CAA0C;EAC1C,sCAAsC;EACtC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,gEAAgE;AAClE;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,wEAAwE;AACxE;EACE,sDAAsD;EACtD,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;EAEE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;EAIE,oCAAoC;EACpC,8CAA8C;EAC9C,wDAAwD;AAC1D;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;;EAGE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA,oCAAoC;AACpC;EACE,oCAAoC;AACtC;AACA;EACE,4BAA4B;AAC9B;;AAEA;;;0CAG0C;AAC1C;EACE;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;AACF;;AAEA,gBAAgB;AAChB;EACE,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;2EAG2E;AAC3E;EACE,4DAA4D;EAC5D,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,sEAAsE;AACtE;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;;;mDAGmD;AACnD;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;6EAC6E;AAC7E;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uEAAuE;AACvE;EACE,wCAAwC;AAC1C;;AAEA;uEACuE;AACvE;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;+CAC+C;AAC/C;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB,IAAI,gDAAgD;EACzE,SAAS;EACT,iBAAiB,QAAQ,qEAAqE;AAChG;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;qFAEqF;AACrF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,WAAW;AACb;;AAEA;;4EAE4E;AAC5E;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd;gDAC8C;AAChD;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,kGAAkG;EAClG,+CAA+C;AACjD;AACA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,uBAAuB;EACvB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA,uEAAuE;AACvE;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,sEAAsE;AACtE;wEACwE;AACxE;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA,uEAAuE;AACvE,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,uEAAuE;AACvE;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,0CAA0C;EAC1C,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B;;sBAEoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,uEAAuE;AACvE;EACE,2BAA2B;AAC7B;;AAEA,uEAAuE;AACvE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd;;oDAEkD;EAClD,wBAAwB;EACxB,iBAAiB;EACjB,2BAA2B;EAC3B,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,uEAAuE;AACvE;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,uEAAuE;AACvE,cAAc,gBAAgB,EAAE;AAChC,uBAAuB,qBAAqB,EAAE;AAC9C,uBAAuB,gBAAgB,EAAE;AACzC,uBAAuB,yBAAyB,EAAE;;AAElD;EACE,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,2BAA2B,iBAAiB,EAAE,kBAAkB,EAAE;;AAElE,8DAA8D;AAC9D;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA,gCAAgC,uBAAuB,EAAE;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,qDAAqD;AACvD;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;AACA,eAAe,gCAAgC,EAAE;AACjD,qBAAqB,0BAA0B,EAAE;;AAEjD;EACE,cAAc,eAAe,EAAE;EAC/B,iBAAiB,0BAA0B,EAAE,SAAS,EAAE;EACxD,aAAa,gBAAgB,EAAE;EAC/B,cAAc,0BAA0B,EAAE,SAAS,EAAE;EACrD,YAAY,0BAA0B,EAAE,MAAM,EAAE;EAChD,YAAY,eAAe,EAAE;AAC/B;;AAEA,uEAAuE;AACvE,eAAe,eAAe,EAAE;AAChC,yBAAyB,qBAAqB,EAAE;AAChD,yBAAyB,gBAAgB,EAAE;AAC3C,yBAAyB,yBAAyB,EAAE;;AAEpD;EACE,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,6BAA6B,iBAAiB,EAAE,kBAAkB,EAAE;;AAEpE,sCAAsC;AACtC;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA,gBAAgB,iCAAiC,EAAE;AACnD,2BAA2B,oCAAoC,EAAE;AACjE;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA,sBAAsB,gCAAgC,EAAE;AACxD,4BAA4B,0BAA0B,EAAE;;AAExD,gEAAgE;AAChE;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,eAAe,eAAe,EAAE;EAChC,kBAAkB,0BAA0B,EAAE,SAAS,EAAE;EACzD,aAAa,gBAAgB,EAAE;EAC/B,gBAAgB,0BAA0B,EAAE,MAAM,EAAE;EACpD,gBAAgB,0BAA0B,EAAE,SAAS,EAAE;EACvD,eAAe,0BAA0B,EAAE,SAAS,EAAE;EACtD,aAAa,eAAe,EAAE;EAC9B,aAAa,eAAe,EAAE;AAChC;;AAEA;;;;;oDAKoD;AACpD,oBAAoB,aAAa,EAAE;;AAEnC;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;EACf;EACA,gEAAgE,YAAY,EAAE;;EAE9E;kFACgF;EAChF,mDAAmD,kBAAkB,EAAE;AACzE","sourcesContent":["/* ================================================================\n   SoltArc — Architectural Theme Overrides\n   Loaded after public/assets/css/style.css via index.js import.\n   Rules here win by specificity / !important where needed.\n   ================================================================ */\n\n/* ─── DESIGN TOKENS ────────────────────────────────────────────── */\n:root {\n  --bg:        #F7F5F2;\n  --bg-alt:    #EEEAE5;\n  --ink:       #1A1A1A;\n  --ink-muted: #7A736B;\n  --accent:    #3F97A0;\n  --line:      #D8D3CD;\n  --dark:      #141414;\n}\n\n/* ─── GLOBAL ────────────────────────────────────────────────────── */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  background-color: var(--bg);\n  color: var(--ink);\n  font-family: 'Poppins', sans-serif;\n  font-weight: 300;\n  font-size: 15px;\n  line-height: 1.85;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n::selection {\n  background-color: var(--accent);\n  color: #fff;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* ─── BACKGROUNDS ───────────────────────────────────────────────── */\nbody,\n.bg-white {\n  background-color: var(--bg) !important;\n}\n\n.bg-gray {\n  background-color: var(--bg-alt) !important;\n}\n\n/* ─── TYPOGRAPHY ────────────────────────────────────────────────── */\nh1, h2 {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  color: var(--ink);\n  letter-spacing: -0.01em;\n  line-height: 1.15;\n}\n\nh1 { font-size: 64px; }\nh2 { font-size: 48px; }\n\nh3 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--ink);\n}\n\nh4 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--ink);\n}\n\nh5, h6 {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 600;\n  color: var(--ink);\n}\n\np {\n  color: var(--ink-muted);\n  font-weight: 300;\n  line-height: 1.85;\n}\n\n@media (max-width: 768px) {\n  h1 { font-size: 42px; }\n  h2 { font-size: 34px; }\n  h3 { font-size: 22px; }\n}\n\n/* ─── SECTION LAYOUT ─────────────────────────────────────────────── */\n.content-inner-2 {\n  padding-top: 100px !important;\n  padding-bottom: 100px !important;\n}\n\n.section-head {\n  margin-bottom: 48px;\n}\n\n/* Strip the decorative cross-line background from separators */\n.sx-separator-outer,\n.sx-separator {\n  background-image: none !important;\n  border: none !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.sx-separator .sep-line-one {\n  font-family: 'Cormorant Garamond', Georgia, serif !important;\n  font-size: 42px !important;\n  font-weight: 300 !important;\n  color: var(--ink) !important;\n  background: none !important;\n  border: none !important;\n  padding: 0 !important;\n}\n\n/* Elimina las rayitas/líneas negras que el tema dibuja a los lados (y a veces\n   encima) de los títulos .sep-line-one mediante los pseudo-elementos\n   :before/:after (background:#000; height:4px). Las queremos fuera en TODO el\n   sitio, sin importar el wrapper (.sx-separator-outer.separator-left/right/center). */\n.sep-line-one::before,\n.sep-line-one::after {\n  display: none !important;\n  content: none !important;\n}\n\n/* ─── BUTTONS ─────────────────────────────────────────────────────── */\n.site-button {\n  background-color: transparent !important;\n  border: 1.5px solid var(--accent) !important;\n  color: var(--ink) !important;\n  font-family: 'Poppins', sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  padding: 14px 32px;\n  border-radius: 0 !important;\n  transition: background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;\n}\n\n.site-button:hover,\n.site-button:focus {\n  background-color: var(--accent) !important;\n  border-color: var(--accent) !important;\n  color: #fff !important;\n  text-decoration: none;\n}\n\n.site-button-secondry {\n  background-color: var(--ink) !important;\n  border: 1.5px solid var(--ink) !important;\n  color: #fff !important;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  padding: 14px 32px;\n  border-radius: 0 !important;\n  transition: background-color 0.25s ease, border-color 0.25s ease;\n}\n\n.site-button-secondry:hover {\n  background-color: var(--accent) !important;\n  border-color: var(--accent) !important;\n  color: #fff !important;\n}\n\n.site-button-link {\n  color: var(--accent) !important;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  text-decoration: none !important;\n  transition: color 0.2s ease;\n}\n\n.site-button-link:hover {\n  color: var(--ink) !important;\n  text-decoration: none !important;\n}\n\n/* ─── HEADER ──────────────────────────────────────────────────────── */\n.site-header .main-bar {\n  background-color: rgba(247, 245, 242, 0.96) !important;\n  border-bottom: 1px solid var(--line);\n  backdrop-filter: blur(8px);\n}\n\n.site-header.sticky-header .main-bar,\n.site-header.color-fill .main-bar {\n  background-color: var(--bg) !important;\n  box-shadow: 0 1px 0 var(--line);\n}\n\n.header-nav .nav > li > a {\n  color: var(--ink) !important;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.header-nav .nav > li > a:hover,\n.header-nav .nav > li.active > a {\n  color: var(--accent) !important;\n}\n\n.header-nav .nav > li > ul.sub-menu,\n.header-nav .nav > li > ul.mega-menu,\n.header-nav .nav > li ul.sub-menu,\n.header-nav .nav > li ul.sub-menu li ul.sub-menu {\n  background-color: #ffffff !important;\n  border-top: 2px solid var(--accent) !important;\n  box-shadow: 0 8px 24px rgba(20, 20, 20, 0.08) !important;\n}\n\n.header-nav .nav > li ul.sub-menu li,\n.header-nav .nav > li ul.sub-menu li > a {\n  background-color: #ffffff !important;\n}\n\n.header-nav .nav > li ul.sub-menu li a {\n  color: var(--ink) !important;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  text-transform: none;\n  padding: 10px 18px !important;\n}\n\n.header-nav .nav > li ul.sub-menu li a:hover,\n.header-nav .nav > li ul.sub-menu li:hover > a,\n.header-nav .nav > li ul.sub-menu li.active > a {\n  color: var(--accent) !important;\n  background-color: var(--bg-alt) !important;\n}\n\n/* Mobile drawer — same legibility */\n.mobile-sider-drawer-menu .header-nav .nav li ul.sub-menu {\n  background-color: #ffffff !important;\n}\n.mobile-sider-drawer-menu .header-nav .nav li ul.sub-menu li a {\n  color: var(--ink) !important;\n}\n\n/* Drawer móvil ABIERTO: los items de primer nivel van sobre el panel OSCURO →\n   texto crema legible. Doble guarda: SOLO en ancho móvil (≤991px, donde el nav\n   se vuelve drawer) y con .active. Así el nav de ESCRITORIO (texto oscuro sobre\n   la barra clara) NUNCA se ve afectado. */\n@media (max-width: 991px) {\n  .mobile-sider-drawer-menu.active .header-nav .nav > li > a {\n    color: var(--bg) !important;\n  }\n  .mobile-sider-drawer-menu.active .header-nav .nav > li > a:hover,\n  .mobile-sider-drawer-menu.active .header-nav .nav > li.active > a {\n    color: var(--accent) !important;\n  }\n}\n\n/* Mobile menu */\n.mobile-nav > li > a {\n  color: var(--ink) !important;\n}\n\n/* ─── SERVICE CARDS — minimalist numbered grid ─────────────────── */\n.svc-section-label {\n  font-family: 'Poppins', sans-serif;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n  color: var(--accent);\n  margin: 0 0 12px 0;\n}\n\n/* El tema aplica `.section-head h2 { font-family: Poppins }` (mayor especificidad\n   que esta clase) + el `h2 { font-weight: 600 }` global, lo que hacía que este\n   título saliera en Poppins negrita. Forzamos la tipografía serif fina y elegante\n   (Cormorant Garamond 300), igual que el resto de los títulos del sitio. */\n.svc-section-title {\n  font-family: 'Cormorant Garamond', Georgia, serif !important;\n  font-size: 48px;\n  font-weight: 300 !important;\n  color: var(--ink);\n  margin: 0 0 56px 0;\n  line-height: 1.15;\n  letter-spacing: -0.01em;\n}\n\n.svc-card {\n  padding: 36px 0;\n  border-top: 1px solid var(--line);\n  transition: border-top-color 0.25s ease;\n  height: 100%;\n}\n\n.svc-card:hover {\n  border-top-color: var(--accent);\n}\n\n.svc-number {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-size: 17px;\n  font-weight: 300;\n  line-height: 1;\n  color: var(--line);\n  margin-bottom: 6px;\n  display: block;\n  transition: color 0.25s ease;\n}\n\n.svc-card:hover .svc-number {\n  color: var(--accent);\n}\n\n.svc-title {\n  font-family: 'Poppins', sans-serif !important;\n  font-size: 10px !important;\n  font-weight: 600 !important;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  color: var(--ink) !important;\n  margin: 0 0 14px 0 !important;\n}\n\n.svc-desc {\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 1.85;\n  color: var(--ink-muted);\n  margin-bottom: 22px;\n}\n\n.svc-link {\n  font-family: 'Poppins', sans-serif;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--accent);\n  text-decoration: none !important;\n  display: inline-block;\n  transition: color 0.2s ease;\n}\n\n.svc-link:hover {\n  color: var(--ink);\n  text-decoration: none !important;\n}\n\n/* ─── ABOUT SECTION ─────────────────────────────────────────────── */\n.about-home-left h2 {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 48px;\n  color: var(--ink);\n  line-height: 1.2;\n}\n\n/* ─── INNER PAGE BANNER ──────────────────────────────────────────── */\n/* El tema deja el banner en 500px (demasiado alto). Lo hacemos compacto pero con\n   min-height (no height fijo) para que CREZCA cuando el texto es largo (p.ej.\n   Protección de Datos) y no se corte arriba. El padding-top da aire al título\n   para que nunca quede pegado al borde superior. */\n.sx-bnr-inr {\n  height: auto;\n  min-height: 340px;\n}\n\n/* padding-top generoso: el header fijo (~80px) se monta sobre el banner, así\n   que el título necesita ese colchón para no quedar pegado/cortado arriba. */\n.sx-bnr-inr-entry {\n  padding-top: 110px;\n  padding-bottom: 40px;\n}\n\n@media (max-width: 768px) {\n  .sx-bnr-inr {\n    min-height: 280px;\n  }\n  .sx-bnr-inr-entry {\n    padding-top: 80px;\n    padding-bottom: 32px;\n  }\n}\n\n.sx-bnr-inr h2 {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  letter-spacing: -0.01em;\n}\n\n/* ─── FOOTER ─────────────────────────────────────────────────────── */\n.site-footer {\n  background-color: var(--dark) !important;\n}\n\n/* Contenedor del footer más ancho: cada bloque se ancla a su orilla (en vez de\n   flotar en un contenedor angosto centrado). Recargado de cada lado. */\n.site-footer .container {\n  width: 90%;\n  max-width: 1500px;\n}\n\n/* Distribución del footer: bloque izquierdo pegado a la izquierda, bloque\n   derecho pegado a la derecha, centro vacío. */\n.footer-split {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 48px;\n  flex-wrap: wrap;\n}\n.footer-split-left {\n  flex: 0 1 360px;\n  min-width: 250px;\n}\n.footer-split-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;   /* empuja columnas y botón a la orilla derecha */\n  gap: 28px;\n  text-align: right;       /* títulos/datos alineados a la derecha (espejo del lado izquierdo) */\n}\n.footer-right-cols {\n  display: flex;\n  gap: 72px;\n}\n.footer-right-cols .widget {\n  margin-bottom: 0;\n}\n/* El bloque \"Conoce más / Envíanos un mensaje\" ahora vive en la columna derecha,\n   debajo del botón CONTÁCTANOS. Le damos aire respecto al botón (arriba) y, por el\n   gap de .footer-split-right, también respecto a los datos de contacto (teléfono). */\n.footer-cta {\n  margin-top: 14px;\n  padding-top: 22px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  width: 100%;\n}\n\n/* ─── REDES SOCIALES DEL FOOTER ──────────────────────────────────────\n   Círculo sutil con el icono blanco (se ve de qué red es) y, al pasar el\n   cursor, se rellena con el color de la marca + un pequeño levantamiento. */\n.site-footer .footer-social {\n  display: flex;\n  gap: 12px;\n  margin: 10px 0 0;\n  padding: 0;\n}\n.site-footer .footer-social li {\n  margin: 0;\n  padding: 0;\n}\n.site-footer .footer-social li a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: #fff !important;\n  font-size: 17px;\n  line-height: 1;\n  transition: transform 0.2s ease, background 0.2s ease,\n    border-color 0.2s ease, box-shadow 0.2s ease;\n}\n.site-footer .footer-social li a:hover {\n  transform: translateY(-3px);\n  color: #fff !important;\n  border-color: transparent;\n}\n.site-footer .footer-social .social-fb:hover {\n  background: #1877f2;\n  box-shadow: 0 6px 16px rgba(24, 119, 242, 0.45);\n}\n.site-footer .footer-social .social-ig:hover {\n  background: radial-gradient(circle at 30% 110%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285aeb 90%);\n  box-shadow: 0 6px 16px rgba(214, 36, 159, 0.45);\n}\n.site-footer .footer-social .social-in:hover {\n  background: #0a66c2;\n  box-shadow: 0 6px 16px rgba(10, 102, 194, 0.45);\n}\n\n@media (max-width: 767px) {\n  .footer-split {\n    flex-direction: column;\n    gap: 40px;\n  }\n  .footer-split-right {\n    align-items: flex-start;\n    text-align: left;\n  }\n  .footer-right-cols {\n    gap: 40px;\n  }\n}\n\n.site-footer p {\n  color: rgba(255, 255, 255, 0.5) !important;\n  font-weight: 300;\n  font-size: 13px;\n}\n\n.site-footer h3,\n.site-footer h4,\n.site-footer h5,\n.site-footer .widget-title {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 400;\n  font-size: 20px;\n  color: #fff !important;\n  letter-spacing: 0;\n}\n\n.site-footer a {\n  color: rgba(255, 255, 255, 0.55) !important;\n  font-size: 13px;\n  font-weight: 300;\n  letter-spacing: 0.3px;\n  transition: color 0.2s ease;\n}\n\n.site-footer a:hover {\n  color: var(--accent) !important;\n  text-decoration: none;\n}\n\n.footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.08) !important;\n}\n\n.site-footer .site-button {\n  border-color: var(--accent) !important;\n  color: #fff !important;\n}\n\n.site-footer .site-button:hover {\n  background-color: var(--accent) !important;\n  color: #fff !important;\n}\n\n/* ─── CLIENT LOGOS ───────────────────────────────────────────────── */\n.ow-client-logo img {\n  filter: grayscale(100%);\n  opacity: 0.45;\n  transition: filter 0.3s ease, opacity 0.3s ease;\n}\n\n.ow-client-logo img:hover {\n  filter: grayscale(0%);\n  opacity: 1;\n}\n\n/* ─── LEGACY ICON BOXES (non-Services pages) ─────────────────────── */\n.icon-count-2-outer {\n  box-shadow: none !important;\n  border: 1px solid var(--line) !important;\n  border-radius: 0 !important;\n  transition: border-color 0.25s ease;\n}\n\n.icon-count-2-outer:hover {\n  box-shadow: none !important;\n  border-color: var(--accent) !important;\n}\n\n.icon-count-2 {\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n/* ─── MODULE HERO IMAGE (Services detail + Modulo pages) ────────── */\n/* The PNG illustration for each of the 6 modules, half the size of\n   the default block so it reads as a feature image, not a giant hero. */\n.module-hero {\n  text-align: center;\n}\n\n.module-hero-img {\n  display: inline-block;\n  width: 50%;\n  max-width: 320px;\n  height: auto;\n}\n\n@media (max-width: 768px) {\n  .module-hero-img {\n    width: 70%;\n    max-width: 240px;\n  }\n}\n\n/* ─── CTA ICON BOXES (Services detail pages) ─────────────────────── */\n/* Half the size the template ships with. */\n.sx-icon-box-lg {\n  width: 50px !important;\n  height: 50px !important;\n  line-height: 50px !important;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 14px !important;\n}\n\n.sx-icon-box-lg .icon-cell,\n.sx-icon-box-lg i {\n  font-size: 22px !important;\n  line-height: 1 !important;\n}\n\n.sx-icon-box-md {\n  width: 40px !important;\n  height: 40px !important;\n  line-height: 40px !important;\n}\n\n.sx-icon-box-md .icon-cell,\n.sx-icon-box-md i {\n  font-size: 18px !important;\n}\n\n/* ─── OWL CAROUSEL ───────────────────────────────────────────────── */\n.owl-theme .owl-dots .owl-dot.active span,\n.owl-theme .owl-dots .owl-dot:hover span {\n  background: var(--accent) !important;\n}\n\n.owl-theme .owl-nav [class*='owl-'] {\n  background: transparent !important;\n  color: var(--accent) !important;\n  border: 1px solid var(--accent) !important;\n  border-radius: 0 !important;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.owl-theme .owl-nav [class*='owl-']:hover {\n  background: var(--accent) !important;\n  color: #fff !important;\n}\n\n/* ─── DECORATIVE BG TEXT ─────────────────────────────────────────── */\n.hilite-title {\n  display: none;\n}\n\n/* ─── SCROLL TO TOP ──────────────────────────────────────────────── */\nbutton.scroltop {\n  background-color: var(--accent) !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  /* Apilado SOBRE la burbuja de chat (bottom:28 + 52px alto + 12 de gap), mismo\n     borde derecho, para que no se encimen. z-index < chat (9999): si el chat se\n     abre, lo cubre. */\n  right: 28px !important;\n  bottom: 92px !important;\n  z-index: 9998 !important;\n}\n\n/* ─── GLOBAL LINK TRANSITIONS ────────────────────────────────────── */\na {\n  transition: color 0.2s ease;\n}\n\n/* ─── LANGUAGE SWITCH (ES / EN) ──────────────────────────────────── */\n.lang-switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.lang-btn {\n  background: transparent;\n  border: none;\n  padding: 4px 6px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--ink-muted);\n  cursor: pointer;\n  transition: color 0.2s ease;\n  line-height: 1;\n}\n\n.lang-btn:hover {\n  color: var(--ink);\n}\n\n.lang-btn.is-active {\n  color: var(--accent);\n}\n\n.lang-sep {\n  color: var(--line);\n  font-size: 11px;\n  font-weight: 300;\n  user-select: none;\n}\n\n/* ─── ABOUT · SoltArc (editorial) ──────────────────────────────────── */\n.about-copra {\n  background: var(--bg);\n  padding: 110px 0;\n}\n\n.about-copra-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);\n  gap: 72px;\n  align-items: center;\n}\n\n/* Imagen con marco desfasado en color de acento (toque editorial). */\n.about-copra-figure {\n  position: relative;\n  margin: 0;\n}\n.about-copra-figure::before {\n  content: '';\n  position: absolute;\n  left: -22px;\n  top: 22px;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--accent);\n  opacity: 0.5;\n  z-index: 0;\n  pointer-events: none;\n}\n.about-copra-figure .ac-img {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  aspect-ratio: 4 / 5;\n  background-size: cover;\n  background-position: center;\n  filter: grayscale(100%) contrast(1.02);\n  transition: filter 0.7s ease;\n}\n.about-copra-figure:hover .ac-img {\n  filter: grayscale(0%);\n}\n\n.about-copra-eyebrow {\n  font-family: 'Poppins', sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.24em;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent);\n  margin: 0 0 20px;\n}\n\n.about-copra-title {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 60px;\n  line-height: 1;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n  margin: 0 0 24px;\n}\n\n.about-copra-rule {\n  width: 56px;\n  height: 2px;\n  background: var(--accent);\n  margin: 0 0 30px;\n}\n\n.about-copra-lead {\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  line-height: 1.75;\n  font-weight: 400;\n  color: var(--ink);\n  margin: 0 0 24px;\n}\n\n.about-copra-body p {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  line-height: 1.9;\n  font-weight: 300;\n  color: var(--ink-muted);\n  margin: 0 0 18px;\n}\n.about-copra-body p:last-child {\n  margin-bottom: 0;\n}\n\n@media (max-width: 991px) {\n  .about-copra {\n    padding: 64px 0;\n  }\n  .about-copra-grid {\n    grid-template-columns: 1fr;\n    gap: 48px;\n  }\n  .about-copra-figure {\n    max-width: 460px;\n  }\n  .about-copra-figure::before {\n    left: -12px;\n    top: 12px;\n  }\n  .about-copra-title {\n    font-size: 46px;\n  }\n  .about-copra-lead {\n    font-size: 16.5px;\n  }\n}\n\n/* ─── ABOUT · feature (texto + media, minimalista) ───────────────── */\n.about-feature {\n  background: #fff;\n  padding: 110px 0;\n}\n\n.about-feature-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 72px;\n  align-items: center;\n}\n\n.about-feature-eyebrow {\n  font-family: 'Poppins', sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.24em;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent);\n  margin: 0 0 20px;\n}\n\n.about-feature-title {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 44px;\n  line-height: 1.08;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n  margin: 0 0 24px;\n}\n\n.about-feature-rule {\n  width: 56px;\n  height: 2px;\n  background: var(--accent);\n  margin: 0 0 28px;\n}\n\n.about-feature-text {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  line-height: 1.9;\n  font-weight: 300;\n  color: var(--ink-muted);\n  margin: 0 0 34px;\n}\n\n/* Enlace minimalista con flecha (en vez del botón con caja). */\n.about-feature-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: var(--ink);\n  text-decoration: none;\n  padding-bottom: 6px;\n  border-bottom: 1px solid var(--ink);\n  transition: color 0.25s ease, border-color 0.25s ease;\n}\n.about-feature-link:hover {\n  color: var(--accent);\n  border-color: var(--accent);\n  text-decoration: none;\n}\n.about-feature-link .arw {\n  transition: transform 0.25s ease;\n}\n.about-feature-link:hover .arw {\n  transform: translateX(5px);\n}\n\n/* Media: imagen con marco de acento desfasado (espejo del de SoltArc). */\n.about-feature-media {\n  position: relative;\n  line-height: 0;\n}\n.about-feature-media::after {\n  content: '';\n  position: absolute;\n  right: -22px;\n  bottom: -22px;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--accent);\n  opacity: 0.5;\n  z-index: 0;\n  pointer-events: none;\n}\n.about-feature-media video,\n.about-feature-media img {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  display: block;\n  /* Recorta ~10% del borde inferior para ocultar la marca de agua (estrella)\n     de la esquina inferior derecha. Imagen 944x1130 → se muestra 944x1017,\n     anclada arriba (object-position: center top). */\n  aspect-ratio: 944 / 1017;\n  object-fit: cover;\n  object-position: center top;\n  filter: grayscale(100%) contrast(1.02);\n  transition: filter 0.7s ease;\n}\n.about-feature-media:hover video,\n.about-feature-media:hover img {\n  filter: grayscale(0%);\n}\n\n@media (max-width: 991px) {\n  .about-feature {\n    padding: 64px 0;\n  }\n  .about-feature-grid {\n    grid-template-columns: 1fr;\n    gap: 44px;\n  }\n  .about-feature-title {\n    font-size: 36px;\n  }\n  .about-feature-media::after {\n    right: -12px;\n    bottom: -12px;\n  }\n}\n\n/* ─── ABOUT · declaración de cierre (minimalista) ────────────────── */\n.about-statement {\n  background: var(--bg);\n  padding: 96px 0;\n  text-align: center;\n}\n\n.about-statement-inner {\n  max-width: 760px;\n  margin: 0 auto;\n}\n\n/* Pequeña marca de acento centrada (sustituye las rayitas del sep-line-one). */\n.about-statement-mark {\n  width: 48px;\n  height: 2px;\n  background: var(--accent);\n  margin: 0 auto 30px;\n}\n\n/* El texto se trata como una cita/lead en serif, no como título. */\n.about-statement p {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 27px;\n  line-height: 1.55;\n  letter-spacing: 0.005em;\n  color: var(--ink);\n  margin: 0;\n}\n\n@media (max-width: 991px) {\n  .about-statement {\n    padding: 64px 0;\n  }\n  .about-statement p {\n    font-size: 22px;\n  }\n}\n\n/* ─── PROTECCIÓN DE DATOS (minimalista / moderno) ────────────────── */\n.dp-section { padding: 104px 0; }\n.dp-section.dp-cream { background: var(--bg); }\n.dp-section.dp-white { background: #fff; }\n.dp-section.dp-alt   { background: var(--bg-alt); }\n\n.dp-eyebrow {\n  font-family: 'Poppins', sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.24em;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent);\n  margin: 0 0 18px;\n}\n.dp-title {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 40px;\n  line-height: 1.12;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n  margin: 0 0 22px;\n}\n.dp-rule {\n  width: 56px;\n  height: 2px;\n  background: var(--accent);\n  margin: 0 0 26px;\n}\n.dp-text {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  line-height: 1.9;\n  font-weight: 300;\n  color: var(--ink-muted);\n  margin: 0;\n}\n.dp-head-center {\n  text-align: center;\n  max-width: 680px;\n  margin: 0 auto 56px;\n}\n.dp-head-center .dp-rule { margin-left: auto; margin-right: auto; }\n\n/* Sección 1 — intro: visual minimalista (SVG línea) + texto */\n.dp-intro-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n  gap: 72px;\n  align-items: center;\n}\n.dp-figure {\n  position: relative;\n  aspect-ratio: 1 / 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 1px solid var(--line);\n}\n.dp-figure::after {\n  content: '';\n  position: absolute;\n  left: -20px;\n  top: 20px;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--accent);\n  opacity: 0.45;\n  z-index: 0;\n  pointer-events: none;\n}\n.dp-figure svg {\n  position: relative;\n  z-index: 1;\n  width: 132px;\n  height: 132px;\n  color: var(--accent);\n}\n\n/* Sección 2 — tres pilares (sin clip-art, número serif) */\n.dp-pillars {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 28px;\n}\n.dp-pillar {\n  background: #fff;\n  border: 1px solid var(--line);\n  padding: 42px 34px;\n  transition: border-color 0.25s ease, transform 0.25s ease;\n}\n.dp-pillar:hover {\n  border-color: var(--accent);\n  transform: translateY(-4px);\n}\n.dp-pillar-num {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 36px;\n  line-height: 1;\n  color: var(--accent);\n  margin: 0 0 22px;\n}\n.dp-pillar h4 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 0;\n}\n\n/* Sección 3 — cómo trabajamos (lista 2 columnas con hairlines) */\n.dp-grid2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 64px;\n}\n.dp-item {\n  padding: 30px 0;\n  border-top: 1px solid var(--line);\n}\n.dp-item-h {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  margin: 0 0 12px;\n}\n.dp-item-num {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 22px;\n  color: var(--accent);\n}\n.dp-item h4 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 0;\n}\n.dp-item p {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  line-height: 1.85;\n  font-weight: 300;\n  color: var(--ink-muted);\n  margin: 0;\n}\n\n/* Acciones / botones minimalistas (reutilizables en datos personales) */\n.dp-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 12px;\n}\n.dp-actions.dp-actions-center { justify-content: center; }\n.dp-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--ink);\n  text-decoration: none;\n  padding: 14px 28px;\n  border: 1px solid var(--line);\n  background: transparent;\n  transition: border-color 0.25s ease, color 0.25s ease;\n}\n.dp-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n  text-decoration: none;\n}\n.dp-btn .arw { transition: transform 0.25s ease; }\n.dp-btn:hover .arw { transform: translateX(4px); }\n\n@media (max-width: 991px) {\n  .dp-section { padding: 64px 0; }\n  .dp-intro-grid { grid-template-columns: 1fr; gap: 44px; }\n  .dp-figure { max-width: 340px; }\n  .dp-pillars { grid-template-columns: 1fr; gap: 18px; }\n  .dp-grid2 { grid-template-columns: 1fr; gap: 0; }\n  .dp-title { font-size: 32px; }\n}\n\n/* ─── DETALLE DE SERVICIOS (minimalista / limpio) ────────────────── */\n.svc-section { padding: 96px 0; }\n.svc-section.svc-cream { background: var(--bg); }\n.svc-section.svc-white { background: #fff; }\n.svc-section.svc-alt   { background: var(--bg-alt); }\n\n.svc-eyebrow {\n  font-family: 'Poppins', sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.24em;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent);\n  margin: 0 0 18px;\n}\n.svc-title {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 40px;\n  line-height: 1.12;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n  margin: 0 0 22px;\n}\n.svc-rule {\n  width: 56px;\n  height: 2px;\n  background: var(--accent);\n  margin: 0 0 26px;\n}\n.svc-text {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15.5px;\n  line-height: 1.9;\n  font-weight: 300;\n  color: var(--ink-muted);\n  margin: 0;\n}\n.svc-head-center {\n  text-align: center;\n  max-width: 680px;\n  margin: 0 auto 52px;\n}\n.svc-head-center .svc-rule { margin-left: auto; margin-right: auto; }\n\n/* Intro: captura del módulo + texto */\n.svc-intro-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);\n  gap: 72px;\n  align-items: center;\n}\n.svc-media {\n  position: relative;\n  line-height: 0;\n}\n.svc-media::after {\n  content: '';\n  position: absolute;\n  left: -20px;\n  bottom: -20px;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--accent);\n  opacity: 0.45;\n  z-index: 0;\n  pointer-events: none;\n}\n.svc-media img {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: auto;\n  display: block;\n  border: 1px solid var(--line);\n}\n\n/* Características: lista limpia en 2 columnas con marca de acento */\n.svc-features {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 56px;\n}\n.svc-feature {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 0;\n  border-top: 1px solid var(--line);\n}\n.svc-feature::before {\n  content: '';\n  flex: 0 0 16px;\n  height: 1px;\n  background: var(--accent);\n  margin-top: 12px;\n}\n.svc-feature span {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--ink);\n}\n\n/* FAQ: acordeón minimalista con hairlines */\n.svc-faq {\n  max-width: 840px;\n  margin: 0 auto;\n}\n.svc-faq-item { border-top: 1px solid var(--line); }\n.svc-faq-item:last-child { border-bottom: 1px solid var(--line); }\n.svc-faq-q {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  padding: 24px 0;\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 1.3;\n  color: var(--ink);\n}\n.svc-faq-q .ind {\n  flex: 0 0 auto;\n  font-family: 'Poppins', sans-serif;\n  font-size: 22px;\n  font-weight: 300;\n  color: var(--accent);\n  line-height: 1;\n}\n.svc-faq-a {\n  padding: 0 0 24px;\n  max-width: 90%;\n}\n.svc-faq-a p {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  line-height: 1.85;\n  font-weight: 300;\n  color: var(--ink-muted);\n  margin: 0;\n}\n\n/* Tarjetas CTA limpias */\n.svc-cta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n.svc-card {\n  background: #fff;\n  border: 1px solid var(--line);\n  padding: 42px 40px;\n  transition: border-color 0.25s ease, transform 0.25s ease;\n}\n.svc-card:hover {\n  border-color: var(--accent);\n  transform: translateY(-4px);\n}\n.svc-card .svc-card-ic {\n  display: block;\n  color: var(--accent);\n  font-size: 26px;\n  margin: 0 0 20px;\n}\n.svc-card h4 {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-weight: 300;\n  font-size: 28px;\n  line-height: 1.1;\n  color: var(--ink);\n  margin: 0 0 12px;\n}\n.svc-card p {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14.5px;\n  line-height: 1.8;\n  font-weight: 300;\n  color: var(--ink-muted);\n  margin: 0 0 22px;\n}\n.svc-card-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--ink);\n  text-decoration: none;\n  padding-bottom: 5px;\n  border-bottom: 1px solid var(--ink);\n  transition: color 0.25s ease, border-color 0.25s ease;\n}\n.svc-card-link:hover {\n  color: var(--accent);\n  border-color: var(--accent);\n  text-decoration: none;\n}\n.svc-card-link .arw { transition: transform 0.25s ease; }\n.svc-card-link:hover .arw { transform: translateX(4px); }\n\n/* Rejilla de 3 tarjetas (p.ej. \"el problema\" de los módulos). */\n.svc-cards-3 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n@media (max-width: 991px) {\n  .svc-section { padding: 64px 0; }\n  .svc-intro-grid { grid-template-columns: 1fr; gap: 44px; }\n  .svc-media { max-width: 560px; }\n  .svc-features { grid-template-columns: 1fr; gap: 0; }\n  .svc-cta-grid { grid-template-columns: 1fr; gap: 18px; }\n  .svc-cards-3 { grid-template-columns: 1fr; gap: 18px; }\n  .svc-title { font-size: 32px; }\n  .svc-faq-a { max-width: 100%; }\n}\n\n/* Menú móvil: botón de cerrar (×) DENTRO del panel oscuro del drawer.\n   El header es transparente, así que el fondo detrás de la hamburguesa\n   cambia por página (claro en Precios, oscuro en Home) y ningún color\n   único de la X sirve. El panel del menú (.header-nav.nav-dark) siempre\n   es oscuro, por eso colocamos ahí una × blanca: visible en toda página\n   y siempre por encima del panel (z-index > 999). */\n.mobile-nav-close { display: none; }\n\n@media only screen and (max-width: 991px) {\n  .mobile-sider-drawer-menu .header-nav .mobile-nav-close {\n    display: block;\n    position: absolute;\n    top: 8px;\n    right: 14px;\n    width: 44px;\n    height: 44px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #fff;\n    font-size: 34px;\n    line-height: 40px;\n    text-align: center;\n    cursor: pointer;\n    z-index: 1001;\n  }\n  .mobile-sider-drawer-menu .header-nav .mobile-nav-close:hover { opacity: 0.7; }\n\n  /* Con el panel abierto, la hamburguesa se oculta: el menú se cierra\n     con la × del panel (evita una X blanca/negra perdida sobre fondo variable). */\n  .mobile-sider-drawer-menu.active .navbar-toggler { visibility: hidden; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
